import React from "react";
import { ContentPanel } from "components/displays";
import {
  ListBuilder,
  ModalBuilder,
  ActionBar,
  Modal,
  Table,
} from "@redriver/cinnamon";
import { TablePagination } from "components/pagination";
import InitialScheduleTermActions from "./InitialScheduleTermActions";
import AddInitialScheduleTermModal from "./AddInitialScheduleTermModal";
import DownloadInitialScheduleTerm from "./DownloadInitialScheduleTerm";
import {
  dateFormatter,
  blankDataFormatter,
  yesNoFormatter,
} from "components/displays/DisplayHelper";
import { Button } from "semantic-ui-react";
import { withPermissions } from "features/../../../shared/components/auth";

const InitialScheduleTermTable = ({
  dealerId,
  title,
  triggerText,
  listAction,
  getAction,
  createAction,
  updateAction,
  deleteAction,
  downloadAction,
  approveAction,
  makeLiveAction,
  canApprove,
  canDownload,
}) => {
  return (
    <ContentPanel
      title={title}
      wrapperCssClass="outline-grid dealers-details"
      headerCssClass="defaults-page-title"
    >
      <ListBuilder
        withTable
        initialPagination={{ pageSize: 25, pageNumber: 1 }}
        loadAction={listAction}
        loadParams={{ dealerId }}
        dataTransform={(data) => data.results}
        totalTransform={(data) => data.totalResults}
        renderList={(tableProps, state, events) => (
          <div className="boiler-plate-TandC-container">
            <ActionBar>
              <ActionBar.Item>
                <AddInitialScheduleTermModal
                  dealerId={dealerId}
                  createAction={createAction}
                  title={`New ${title}`}
                  triggerText={triggerText}
                  onSubmitted={events.onRefresh}
                />
              </ActionBar.Item>
            </ActionBar>
            <Table
              {...tableProps}
              compact
              selectable
              dataKey="id"
              emptyMessage="No Terms Found"
            >
              <Table.Column
                field="reference"
                title="Reference"
                width="8%"
                header="Reference"
              />
              <Table.Column
                field="masterDescription"
                title="Description"
                width="8%"
                header="Description"
              />
              <Table.Column
                field="boilerPlateCode"
                title="Boiler Plate"
                width="8%"
                header="Boiler Plate"
              />
              <Table.Column
                field="variablesNumber"
                title="Variables"
                width="8%"
                header="Variables"
              />
              <Table.Column
                field="lastModified"
                title="Last Modified"
                width="8%"
                header="Last Modified"
                render={(item) =>
                  blankDataFormatter(dateFormatter(item.lastModified), "-")
                }
              />
              <Table.Column
                field="approvedBy1"
                title="First Approver"
                width="8%"
                header="First Approver"
              />
              <Table.Column
                field="approvedBy1Utc"
                title="First Approver Date"
                width="8%"
                header="First Approver Date"
                render={(item) =>
                  blankDataFormatter(dateFormatter(item.approvedBy1Utc), "-")
                }
              />
              <Table.Column
                field="approvedBy2"
                title="Second Approver"
                width="8%"
                header="Second Approver"
              />
              <Table.Column
                field="approvedBy2Utc"
                title="Second Approver Date"
                width="8%"
                header="Second Approver Date"
                render={(item) =>
                  blankDataFormatter(dateFormatter(item.approvedBy2Utc), "-")
                }
              />
              <Table.Column
                field="isLive"
                title="Live"
                width="4%"
                header="Live"
                render={(item) => yesNoFormatter(item.isLive)}
              />
              {canApprove && (
                <Table.Column
                  field="id"
                  width="4%"
                  render={(item) => (
                    <Button.Group basic size="medium">
                      <Approve
                        id={item.id}
                        dealerId={dealerId}
                        approveAction={approveAction}
                        boilerPlateCode={item.boilerPlateCode}
                        reloadTable={events.onRefresh}
                        disabled={!item.requiresApproval}
                      />
                      {canDownload && (
                        <DownloadInitialScheduleTerm
                          item={item}
                          dealerId={dealerId}
                          downloadAction={downloadAction}
                        />
                      )}
                    </Button.Group>
                  )}
                />
              )}
              <Table.Column
                hoverable
                width="4%"
                render={(item) => (
                  <React.Fragment>
                    {!item.isLive && (
                      <InitialScheduleTermActions
                        dealerId={dealerId}
                        item={item}
                        onSubmitted={events.onRefresh}
                        title={title}
                        getAction={getAction}
                        updateAction={updateAction}
                        deleteAction={deleteAction}
                        makeLiveAction={makeLiveAction}
                      />
                    )}
                  </React.Fragment>
                )}
              />
            </Table>
            <TablePagination
              pageNumber={state.pagination.pageNumber}
              onChange={events.onChangePagination}
              pageSize={state.pagination.pageSize}
              totalItems={state.total}
            />
          </div>
        )}
      />
    </ContentPanel>
  );
};

const Approve = ({
  id,
  approveAction,
  boilerPlateCode,
  disabled,
  reloadTable,
  dealerId,
}) => (
  <ModalBuilder
    submitAction={approveAction}
    submitParams={{ id, dealerId }}
    onSubmitted={() => reloadTable()}
    renderTrigger={(showModal) => (
      <Button
        title="Approve"
        primary
        onClick={showModal}
        icon="check"
        disabled={disabled}
      />
    )}
    renderModal={(modalProps) => (
      <Modal.Confirmation {...modalProps} header="Approve">
        Are you sure you wish to approve {boilerPlateCode}?
      </Modal.Confirmation>
    )}
  />
);

export default withPermissions(InitialScheduleTermTable);
